import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import 'isomorphic-fetch'

import './polyfills'

import office from './office/office'
import loft, { appointmentEventLoft } from './services/loft'
import { refreshLocaleData } from './platform/localization'
import { addBreadcrumb } from './sentry-config'
import { initializeAuthMethod } from './office/nested-app-auth/authHelper'

addBreadcrumb({ message: 'Loading APP' })

// IE webview in outlook desktop throws errors
function fixHistory() {
  window.history.pushState = () => {}
  window.history.replaceState = () => {}
}

if (process.env.NODE_ENV === 'development') {
  window['bureau'] = office
  window['devloft'] = () =>
    loft({
      completed: () => {},
      source: { id: '' },
    })
}

// Even if we do nothing in the callback, Office.onReady _must_ be called for the
// Office SDK to initialize properly in the WebView command/launch-event runtime.
// This is the Microsoft-recommended signal (the legacy `Office.initialize`
// callback used by office.initialize() is not guaranteed in this runtime).
// It coexists with the task pane's existing office.initialize() flow.
if (office.isCommandContext) {
  Office.onReady()
}

// Associate launch-event/command handlers synchronously, before any await, so that
// Office can find them the moment OnAppointmentSend fires in the WebView command
// runtime. Deferring this behind `await refreshLocaleData(...)` risks the event
// dispatching before the handler is registered. `registerCommands` is a no-op
// outside the command context, so this is safe in the normal task-pane flow too.
office.registerCommands({
  loft,
  appointmentEventLoft,
})

// eslint-disable-next-line
;(async () => {
  await refreshLocaleData(navigator.language)
  await office.initialize()

  await initializeAuthMethod()

  if (!window.location.origin) {
    const port = window.location.port ? `:${window.location.port}` : ''
    // @ts-expect-error "origin" is read-only initially, but we're trying to fix IE here
    window.location.origin = `${window.location.protocol}//${window.location.hostname}${port}`
  }
  fixHistory()

  if (!office.isCommandContext) {
    const { default: mount } = await import('./mount')
    mount()
  }
})()
